const joi = require('joi');

const schema = joi.object({
  text: joi.string()
    .min(1)
    .max(255)
    .required(),
}).options({ abortEarly: false, stripUnknown: true });

export default schema;
